import { USE_CACHE } from '../common/config';
import { buildModel } from '../common/model';

/* Cache */
const Cache = function () {
  this.cache = {};
  this.reset = function () {
    this.cache = {};
  };
  this.cleanup = function () {

    const cacheMinutes = 1;
    const cacheSize = 32;
    const oldestTime = new Date().getTime() - (1000 * 60 * cacheMinutes);

    const elements = [];
    for (const element in this.cache) {
      if (this.cache[element].time < oldestTime) {
        delete this.cache[element];
      } else {
        elements.push(element);
      }
    }
    const c = this.cache;
    elements.sort(function (a, b) {
      return (c[a].time - c[b].time);
    });
    if (elements.length >= cacheSize) {
      for (let i = 0; i < elements.length - cacheSize; i++) {
        delete this.cache[elements[i]];
      }
    }
  };
};

const cache = new Cache();
window.CACHE = cache;

export function loadWithCache($http, $q, $cookies, $httpParamSerializer) {
  return function (path, params, canceler, resetCache) {
    const requestHash = path + (params ? '?' + $.param(params) : '');
    cache.cleanup();
    if (USE_CACHE && !resetCache && (requestHash in cache.cache)) {
      const timediff = Math.round((new Date().getTime() -
        cache.cache[requestHash].time) / 1000 / 60);
      const result = cache.cache[requestHash].data;
      return $q.when(result);
    }
    const req_params = {};
    if (canceler) {
      req_params['timeout'] = canceler.promise;
    }
    
    req_params['headers'] = {
        'X-CSRFToken': $cookies.get('csrftoken'),
        'Content-Type': 'application/x-www-form-urlencoded',
    };

    return $http.post(path, $httpParamSerializer(params), req_params )
      .then(({data, status, headers, config}) => {
        const model = data;
        cache.cache[requestHash] = {
          'time': new Date().getTime(),
          'data': model,
        };
        return model;
      });
  };
}



// WEBPACK FOOTER //
// ./src/core/cache.service.js